<template>
  <v-dialog
    ref="dialog"
    v-model="dialogOpened"
    max-width="400"
    scrollable
    persistent
    no-click-animation
    :retain-focus="false"
    @keydown.esc="hide"
  >
    <v-card>
      <v-btn class="v-dialog--close" icon @click="hide">
        <v-icon>fal fa-times</v-icon>
      </v-btn>

      <v-card-title class="headline pr-10">
        Nachricht an <i>{{name}}</i> senden
      </v-card-title>

      <v-card-text>
        <v-alert v-if="!peer.connected" type="error" text>
          Verbindung zu diesem Gerät wurde getrennt.
        </v-alert>

        <v-text-field
          ref="textField"
          v-model="text"
          placeholder="Nachricht eingeben"
          outlined
          hide-details
          @keydown.enter="_send"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="hide">
          Abbrechen
        </v-btn>

        <v-btn color="accent" text :disabled="!text || !peer.connected" @click="_send">
          Senden
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Dialog from './Dialog';
  import eventBus from '../../assets/js/event-bus';
  import {focusField} from '../../assets/js/utils';
  import {getUserName} from '../peers/peer-utils';


  export default {
    name: 'TextSendDialog',

    extends: Dialog,

    data() {
      return {
        peer: {},
        text: ''
      };
    },

    computed: {
      name() {
        if (this.peer && this.peer.name) {
          return getUserName(this.peer);
        }
        return null;
      }
    },

    mounted() {
      eventBus.$on('textRecipient', this._onTextRecipient);
    },

    destroyed() {
      eventBus.$off('textRecipient', this._onTextRecipient);
      if (this._unwatch) {
        this._unwatch();
      }
    },

    methods: {
      hide() {
        if (this._unwatch) {
          this._unwatch();
          this._unwatch = null;
        }
        Dialog.methods.hide.call(this);

        this.$nextTick(() => this.text = ''); // Clear input.
      },

      _onTextRecipient(peer) {
        this.peer = {
          ...peer,
          connected: true
        };
        this.show();

        this.$nextTick(() => {
          const input = focusField(this.$refs.textField);
          input.setSelectionRange(0, input.value.length);
          input.setAttribute('autocomplete', 'off');
        });

        // Close dialog and notify user if peer disconnects.
        this._unwatch = this.$store.watch(
          () => this.$store.getters['share/getPeer'](peer.id),
          (peerConnected) => {
            if (!peerConnected && this.peer.connected) {
              this.$set(this.peer, 'connected', false);
              eventBus.$emit('notifyUser', `Verbindung zu ${this.name} wurde getrennt`);
            } else if (peerConnected && !this.peer.connected) {
              this.$set(this.peer, 'connected', true);
              eventBus.$emit('notifyUser', `Verbindung zu ${this.name} wurde wiederhergestellt`);
            }
          }
        );
      },

      _send() {
        if (!this.text) {
          return;
        }

        eventBus.$emit('sendText', {
          to: this.peer.id,
          text: this.text,
          resolve: () => eventBus.$emit('notifyUser', `Nachricht an "${this.name}" versendet`),
          reject: () => eventBus.$emit('notifyUser', `Nachricht an "${this.name}" konnte nicht versendet werden`)
        });

        this.hide();
      }
    }
  };
</script>
